export const pickStringValue = (boolean: boolean, values: [string, string]): string =>
  values[Number(boolean)];
